<template>
  <div class="upsell">
    <div class="upsell-icon"><AppIcon name="lock" :size="22" /></div>
    <h3>{{ title }}</h3>
    <p class="upsell-lead">
      <template v-if="from">Входит в тариф {{ from }} и выше.</template>
      <template v-else>Входит в более высокий тариф.</template>
      Сейчас у вас {{ currentName || 'бесплатный тариф' }}.
    </p>
    <p v-if="hint" class="upsell-hint">{{ hint }}</p>
    <p v-if="keepNote" class="upsell-note">Ранее сохранённые настройки не удаляются: они снова заработают после перехода на подходящий тариф.</p>
    <router-link to="/pricing" class="upsell-cta">Смотреть тарифы</router-link>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import AppIcon from './AppIcon.vue'
import { useTariffInfoStore } from '../stores/tariffInfo'

const props = defineProps({
  feature: { type: String, required: true },
  // показывать пояснение про сохранённые настройки
  keepNote: { type: Boolean, default: true }
})

const tariff = useTariffInfoStore()
onMounted(() => tariff.load())

const title = computed(() => tariff.info?.labels?.[props.feature] || 'Раздел')
const from = computed(() => tariff.info?.available_from?.[props.feature] || '')
const currentName = computed(() => tariff.info?.name || '')

const HINTS = {
  calendar_sync: 'Синхронизация записей с календарями мастеров.',
  waitlist: 'Заявки клиентов и автоматические предложения освободившегося времени.',
  telegram_bot: 'Уведомления клиентам и сотрудникам в Telegram, MAX и WhatsApp. Письма на почту работают на любом тарифе.',
  loyalty_deposits: 'Баллы клиентов и предоплата при онлайн-записи.',
  analytics_extended: 'Расширенная аналитика и расчёт выплат мастерам.',
  tools_pack: 'Учёт материалов, загрузка прайса из файла и редактор писем клиентам.',
  manual_confirmation: 'Новые записи ждут подтверждения администратора.',
  sms_notifications: 'Сообщения клиентам по SMS.',
  resource_planning: 'Кабинеты, аппараты и боксы без двойной записи, рабочие места мастеров.'
}
const hint = computed(() => HINTS[props.feature] || '')
</script>

<style scoped>
.upsell { max-width: 560px; margin: 24px auto; padding: 32px; background: #fff; border: 1px solid #e5e7eb; border-radius: 16px; text-align: center; }
.upsell-icon { display: inline-flex; align-items: center; justify-content: center; width: 48px; height: 48px; border-radius: 50%; background: #fef3c7; color: #b45309; margin-bottom: 12px; }
.upsell h3 { margin: 0 0 8px; font-size: 1.2rem; color: #111827; }
.upsell-lead { margin: 0 0 8px; color: #374151; line-height: 1.5; }
.upsell-hint { margin: 0 0 8px; color: #6b7280; font-size: 14px; line-height: 1.5; }
.upsell-note { margin: 12px 0 0; color: #6b7280; font-size: 13px; line-height: 1.5; }
.upsell-cta { display: inline-block; margin-top: 20px; padding: 10px 20px; border-radius: 10px; background: var(--brand-primary, #4f46e5); color: #fff; font-weight: 600; font-size: 14px; text-decoration: none; }
</style>
